var default_apr = 8.9;

window.financeCalculatorV1 = function financeCalculatorV1() {
    'use strict';

    var $form = '',
        $result = $('#financeBreakdownResults'),
        ajax_url = '';

    if ($('.financeCalculator').length > 0) {
        //refine page FC calls
        $form = $('form.calcWrap');
        ajax_url = '/modules/FinanceCalculator/ajax/finance_calculator_ajax.php?v=1&default_apr='+window.default_apr;

        if (ajax_url != '') {
            $.ajax({
                url: ajax_url,
                type: "post",
                data: $form.serialize(),
                beforeSend: function() {
                    $('.calcBlock').find('.loading').remove();
                    $('.calcBlock').append("<div class='loading'></div>");
                    this.data = this.data.replace('not+sure', 'good');
                    window.default_apr = 0;
                },
                success: function(response) {

                    $result.html(response);
                    $('.calcBlock').find('.loading').remove();

                    if ($('.js_mobileTabs li.active').index() == 1) {
		                $('.csFinanceInfo').show();
	                }
                }
            });
        }
    }
}

$(document).ready(function () {

    /*
     * force strict mode
     */

    'use strict';

    if ($("#financeCalculatorV1").length > 0) {
        financeCalculatorV1();
    }
});